import React from 'react';

import {ActionListItemDescriptor} from './types';
import styles from './ActionList.module.scss';
import classnames from 'classnames';

interface Props {
  items: ActionListItemDescriptor[];
}

export default function ActionList({items}: Props) {
  const itemsMarkup = items.map((item) => {
    const {
      id,
      content,
      image,
      active,
      disabled,
      destructive,
      highlight,
      options,
      onAction,
    } = item;

    const contentClassName = classnames(
      styles.Content,
      disabled && styles.disabled,
      active && styles.active,
      destructive && styles.destructive,
      highlight && styles.highlight,
      image && styles.hasImage,
    );

    const optionsMarkup =
      options &&
      options.map(({id, icon, onClick}, i) => (
        <button
          key={`ActionListOption-${id}-${i}`}
          className={styles.Option}
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onClick();
          }}
        >
          {icon()}
        </button>
      ));

    const thumbnailMarkup = image && (
      <img className={styles.Thumbnail} src={image} alt="thumbnail" />
    );

    return (
      <li className={styles.Item} key={id}>
        <button
          className={styles.Action}
          onClick={disabled ? undefined : onAction}
          type="button"
        >
          <div className={contentClassName}>
            <div className={styles.ImageAndTextWrapper}>
              {thumbnailMarkup}
              <span className={styles.TextContent}>{content}</span>
            </div>
            <div className={styles.OptionsWrapper}>{optionsMarkup}</div>
          </div>
        </button>
      </li>
    );
  });

  return <ol className={styles.ActionList}>{itemsMarkup}</ol>;
}
